<template>
  <div class="activity-box">
    <div class="banner"></div>
    <span class="title">产品优势</span>
    <div class="content-1">
      <span class="content-1-box content-1-box1">
        <span class="base-span">基础功能
              限时免费</span>
        <span class="dec-span">
          支持实体店各类日常管理
          不花钱也能用上好软件
        </span>
      </span>
      <span class="content-1-box content-1-box2">
<span class="base-span">门店网店
全打通</span>
        <span class="dec-span">
          线上线下同步互通
无需分开搭理 轻松运营
        </span>
      </span>
      <span class="content-1-box content-1-box3">
<span class="base-span base-span1">一个软件解决所有
开店问题</span>
        <span class="dec-span">
          会员 收银 商品
一个软件轻松管理
        </span>
      </span>
      <span class="content-1-box content-1-box4">
<span class="base-span base-span2">支持多端登录 无需更换硬件</span>
        <span class="dec-span">
          手机 电脑 收银一体机
手持pos机 iPad
        </span>
      </span>
    </div>
    <span class="title">8大行业解决方案</span>
    <div class="content-2">
     <span class="left-box">
        <span>
          <!-- <img src="../../assets/images/logo/logo_512.png" alt=""> -->
          <span class="span-1">小程序解决方案</span>
        </span>
      <span>
        <!-- <img src="../../assets/images/new-activity/fuwuhangye.png" alt=""> -->
        <span class="span-2">服务行业解决方案</span>
      </span>
      <span>
        <!-- <img src="../../assets/images/new-activity/liansuojiejue.png" alt=""> -->
        <span class="span-3">连锁店解决方案</span>
      </span>
      <span>
        <!-- <img src="../../assets/images/new-activity/canying.png" alt=""> -->
        <span class="span-4">餐饮解决方案</span>
      </span>
     </span>

      <span class="right-box">
        <span>
          <!-- <img src="../../assets/images/new-activity/xinlingshou.png" alt=""> -->
          <span class="span-5">新零售解决方案</span>
        </span>
        <span>
          <!-- <img src="../../assets/images/new-activity/muying.png" alt=""> -->
          <span class="span-6">母婴解决方案</span>
        </span>
        <span>
          <!-- <img src="../../assets/images/new-activity/saomajiejue.png" alt=""> -->
         <span class="span-7">扫码收款解决方案</span>
        </span>
        <span>
          <!-- <img src="../../assets/images/new-activity/pifa.png" alt=""> -->
          <span class="span-8">批发行业解决方案</span>
        </span>
      </span>
    </div>
    
    <div class="content-3">
      <span class="content-title">门店管理</span>
      <img src="../../assets/images/new-activity/mendianguanli.png" alt="" class="content-img">
      <span class="content-wordbox">
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/shouying.png" alt="">
          <span>
            <span>收银管理：</span>
            <span>清楚每一笔销售，管好每一笔钱</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/stock.png" alt="">
          <span>
            <span>商品库存管理：</span>
            <span>货品成千上万，轻松管理，门店网店全统一</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/dianyuanguanli.png" alt="">
          <span>
            <span>店员管理：</span>
            <span>清楚每一笔销售，管好每一笔钱</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/liansuo.png" alt="">
          <span>
            <span>连锁店管理：</span>
            <span>店铺间会员、优惠券等互通，管理一步到位</span>
          </span>
        </span>
      </span>
    </div>
     <div class="content-3">
       <span class="content-title">会员营销</span>
       <img src="../../assets/images/new-activity/yingxiao.png" alt="" class="content-img2">
             <span class="content-wordbox">
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/duanxin.png" alt="">
          <span>
            <span>短信营销：</span>
            <span>低成本高质量触达顾客，数百种短信模板</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/wechatcard.png" alt="">
          <span>
            <span>微信会员卡：</span>
            <span>直连微信卡券，高端大气，营销通知免费发</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/wxstore.png" alt="">
          <span>
            <span>小程序微信商城：</span>
            <span>清楚每一笔销售，管好每一笔钱</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/huodong.png" alt="">
          <span>
            <span>营销活动中心：</span>
            <span>提供多达40种营销活动组合，吸引新顾客，回顾老顾客，让生意来的更快、更省心</span>
          </span>
        </span>
      </span>
    </div>
     <div class="content-3">
       <span class="content-title">商品管理</span>
       <img src="../../assets/images/new-activity/guanli.png" alt="" class="content-img3">
             <span class="content-wordbox">
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/zhineng.png" alt="">
          <span>
            <span>智能盘点：</span>
            <span>告别复杂的商品盘点流程,帮您快速盘点</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/storeguanli.png" alt="">
          <span>
            <span>商品库存管理：</span>
            <span>可将客人购买过的商品寄存系统内,提升到店率</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/duoguige.png" alt="">
          <span>
            <span>多规格/串码管理：</span>
            <span>支持商品多规格/多串码录入,管理商品多样性</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/kunbang.png" alt="">
          <span>
            <span>商品捆绑销售：</span>
            <span>可将多款商品捆绑组合销售,优惠促销更方便</span>
          </span>
        </span>
      </span>
    </div>
     <div class="content-3">
       <span class="content-title">低费率聚合收款，快又省！</span>
       <img src="../../assets/images/new-activity/difei.png" alt="" class="content-img4">
             <span class="content-wordbox">
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/wx.png" alt="">
          <span>
            <span>微信、支付宝收款，0.35超低费率：</span>
            <span>一年净省500元，支持自定义美团、饿了么等支付方式</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/zhifu.png" alt="">
          <span>
            <span>支付即为会员，留住每一位付款用户：</span>
            <span>顾客付款后即可添加或领卡成为会员</span>
          </span>
        </span>
        <span class="content-wordspan">
          <img src="../../assets/images/new-activity/saoma.png" alt="">
          <span>
            <span>每一款都含扫码硬件：</span>
            <span>套餐搭配新潮流硬件，至少再省200元</span>
          </span>
        </span>
      </span>
    </div>
    <div class="title">添加客服微信了解更多</div>
    <span class="service-box">
      <img src="../../assets/images/new-activity/qrcode.png" alt="">
      <span>全国客服电话</span>
      <span class="phone">400-168-3399</span>
    </span>
    <span class="tel">
      <a href="tel:400-168-3399">
 <img src="../../assets/images/new-activity/tel.png" alt="">
      </a>
     
    </span>
    <span class="signnow" @click="signup()">立即注册</span>
  </div>
</template>
<script>
export default {
  name: 'ActivityBox',
  mixins: [],
  components: {},
  props: {},
  data () {
  },
  mounted () {
    console.log(this.$route.query)
  },
  methods: {
    signup () {
      this.$router.push({
        path: '/agent-register',
        query: {
          agc: this.$route.query.agc,
          source: this.$route.query.source
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/base/_mixin';
@import '../../assets/scss/base/config';
.activity-box{
  width: 100%;
  background-color:white;
  .banner{
    width: 100%;
    height: px2rem(360px);
    background: url('../../assets/images/new-activity/banner.png') top center no-repeat;
    background-size: cover;
  }
  .title{
    height:px2rem(62px);
    font-size: px2rem(44px);
    color: #111A34;
    display:inline-block;
    margin:px2rem(21px) auto 0;
    width: 100%;
    text-align:center;
  }
  .content-1{
    height:px2rem(682px);
    background:url('../../assets/images/new-activity/content-1.png') top center no-repeat;
    background-size: cover;
    margin:px2rem(25px) auto 0;
    width:px2rem(670px);
     display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex-wrap: wrap;

    .content-1-box{
      width: px2rem(280px);
      height: px2rem(200px);
      display: flex;
      flex-direction: column;
      align-items:center;
      justify-content: center;
      .base-span{
             display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex-wrap: wrap;
            width:px2rem(96px);
            color: #111111;
            font-size:px2rem(24px);
            font-weight: 600;
            text-align:center;
      }
      .base-span1{
        width:px2rem(200px);
      }
      .base-span2{
        width:px2rem(160px);
      }
      .dec-span{
        text-align:center;
        color:#666F83;
        font-size:px2rem(22px);
      }
    }
    .content-1-box1{
      width: px2rem(280px);
      height: px2rem(200px);
      margin-top:px2rem(110px);
      margin-left:px2rem(30px);
    }
    .content-1-box2{
      width: px2rem(280px);
      height: px2rem(200px);
      margin-top: px2rem(110px);
      margin-right: px2rem(40px);
    }
    .content-1-box3{
      width: px2rem(280px);
      height: px2rem(200px);
      margin-left:px2rem(30px);
      margin-top:px2rem(40px);
    }
    .content-1-box4{
      width: px2rem(280px);
      height: px2rem(200px);
      margin-top: px2rem(40px);
      margin-right: px2rem(40px);
    }
  }
  .content-2{
    height: px2rem(903px);
    width: px2rem(600px);
    background: url('../../assets/images/new-activity/content-2.png') top center no-repeat;
    background-size: cover;
    margin: px2rem(42px) auto 0;
    .left-box{
      float:left;
      width:px2rem(256px);
      height:px2rem(903px);
      span{
        height: px2rem(200px);
        display:flex;
        align-items:center;
        color:#111A34;
        font-size: px2rem(28px);
        // justify-content: flex-end;
        position:relative;
        flex-direction: column;
        font-weight: 600;
        .span-1{
          height:px2rem(45px);
          position:absolute;
          bottom:0;
        }
        .span-2{
          height:px2rem(45px);
          position:absolute;
          bottom:px2rem(-60px);
        }
        .span-3{
          height:px2rem(45px);
          position:absolute;
          bottom:px2rem(-80px);
          // left:px2rem(60px);
        }
        .span-4{
          height:px2rem(45px);
          position:absolute;
          bottom:px2rem(-100px);
          // left:px2rem(60px);
        }
      }
      
    }
    .right-box{
      float:right;
      width:px2rem(256px);
      height:px2rem(903px);
      span{
        height: px2rem(200px);
        display:flex;
        align-items:center;
        color:#111A34;
        font-size: px2rem(28px);
        //  justify-content: flex-end
        position:relative;
        flex-direction: column;
        font-weight: 600;
        .span-5{
          height:px2rem(45px);
          position:absolute;
          bottom:0;
        }
        .span-6{
          height:px2rem(45px);
          position:absolute;
          bottom:px2rem(-60px);
        }
        .span-7{
          height:px2rem(45px);
          position:absolute;
          bottom:px2rem(-80px);
          // left:px2rem(60px);
        }
        .span-8{
          height:px2rem(45px);
          position:absolute;
          bottom:px2rem(-100px);
          // left:px2rem(60px);
        }
      }
    }
  }
  .content-3{
    width: px2rem(670px);
    height: px2rem(870px);
    background-color:#FFFFFF;
    box-shadow: 0px px2rem(6px) px2rem(20px) px2rem(7px) rgba(240,237,237,0.5);
    border-radius: px2rem(18px);
    margin:px2rem(62px) auto 0;
    display:flex;
    flex-direction: column;
    // align-items: center;
    .content-title{
      width: 100%;
      font-size: px2rem(30px);
      color: #111A34;
      text-align:center;
      display:inline-block;
      margin-top: px2rem(40px);
      font-weight: 600;
    }
    .content-wordbox{
      margin-top: px2rem(57px);
      margin-left: px2rem(60px);
      display: flex;
      flex-direction: column;
      .content-wordspan{
        display:flex;
        color:#666F83;
        font-size:px2rem(26px);
        align-items: flex-start;
        img{
          width: px2rem(34px);
          height: px2rem(34px);
          margin-right: px2rem(12px);
          margin-top:px2rem(8px);
        }
        span{
          display:flex;
          flex-direction: column;
        }
      }
    }
    .content-img{
      width:px2rem(551px);
      height:px2rem(297px);
      margin-left:px2rem(60px);
    }
    .content-img2{
      width:px2rem(550px);
      height:px2rem(335px);
    }
    .content-img3{
      width:px2rem(526px);
      height:px2rem(319px);
    }
    .content-img4{
      width:px2rem(550px);
      height:px2rem(320px);
    }
  }
  .service-box{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items:center;
    padding-bottom:px2rem(80px);
    img{
      width: px2rem(196px);
      height:px2rem(199px);
      margin-top:px2rem(47px);
      margin-bottom:px2rem(22px);
    }
    .phone{
      margin-bottom:px2rem(46px);
    }
  }
  .signnow{
    width: px2rem(750px);
    height: px2rem(112px);
    line-height: px2rem(112px);
    text-align:center;
    position: fixed;
    bottom:0;
    color: white;
    font-size: px2rem(40px);
    background:url('../../assets/images/new-activity/zhuce.png') top center no-repeat;
    background-size: cover;
  }
  .tel{
    width: px2rem(130px);
    height: px2rem(220px);
     position: fixed;
    bottom:px2rem(150px);
    right:px2rem(20px);
    a {
    width: px2rem(130px);
    height: px2rem(220px);
      img{
    width: px2rem(130px);
    height: px2rem(220px);
    }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2eb28f7c